var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4461 43.3436C18.6401 43.3436 20.4187 41.565 20.4187 39.371C20.4187 37.1769 18.6401 35.3983 16.4461 35.3983C14.2521 35.3983 12.4735 37.1769 12.4735 39.371C12.4735 41.565 14.2521 43.3436 16.4461 43.3436Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2823 43.3436C42.4763 43.3436 44.2549 41.565 44.2549 39.371C44.2549 37.1769 42.4763 35.3983 40.2823 35.3983C38.0882 35.3983 36.3096 37.1769 36.3096 39.371C36.3096 41.565 38.0882 43.3436 40.2823 43.3436Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.5H9.57586M9.57586 4.5L14.1546 27.4142M9.57586 4.5L10.5527 9.42638M14.1546 27.4142C14.3507 28.4013 14.8876 29.288 15.6716 29.919C16.4555 30.5501 17.4364 30.8853 18.4425 30.866H39.2817C40.2879 30.8853 41.2688 30.5501 42.0527 29.919C42.8366 29.288 43.3736 28.4013 43.5697 27.4142L47 9.42638H10.5527M14.1546 27.4142L10.5527 9.42638",
    stroke: "black",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgCart;